<div class="layout-footer">
    <i>Copyright 2023</i>
    <span class="font-bold ml-2">{{app_base_data.app_name}}</span>
    <small>(v {{app_base_data.version}})</small>
</div>